<template>
  <filter-bar
    label="Appointment"
    :filter-text="filterText"
    :reset="resetFilters"
  >
    <filter-item>
      <filter-user-attendees
        filter-name="appointments"
        store-module="upNext"
        @change="userAttendeesFilterText = $event"
      ></filter-user-attendees>
    </filter-item>
  </filter-bar>
</template>

<script>
import FilterUserAttendees from "../../../components/filter/FilterUserAttendees";

export default {
  name: "UpNextAppointmentFilter",
  components: {FilterUserAttendees},
  data() {
    return {
      userAttendeesFilterText: null,
    };
  },
  computed: {
    filterText() {
      let array = [];

      if (this.userAttendeesFilterText) array.push(this.userAttendeesFilterText);

      return array.join(" | ");
    }
  },
  methods: {
    resetFilters() {
      this.userAttendeesFilterText = null;

      this.$store.commit("upNext/resetAppointmentsFilters");
    },
  }
};
</script>
